export default "__VITE_ASSET__e4fee8f9__"